import { Component, ViewChild } from '@angular/core';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-rotina-tabset',
  templateUrl: './rotina-tabset.component.html',
  styleUrls: ['./rotina-tabset.component.css']
})
export class RotinaTabsetComponent {
  @ViewChild('tabset', { read: NgbTabset, }) tabset: NgbTabset;

  constructor() {
  }

  voltar(): void {
    if (this.tabset) {
      this.tabset.select('checklist');
    }
  }
}




// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/rotina-tabset/rotina-tabset.component.ts